// extracted by mini-css-extract-plugin
export default {"prompt":"UserPrompt_prompt__x+JRn"};